<script setup>
import { ref } from "vue";
import { useI18n } from "vue-i18n";

import SearchFilters from '@/views/service_providers/components/search_filters.vue'
import SearchResults from '@/views/service_providers/components/search_results.vue'

// I18n
const { t } = useI18n();
</script>

<template>
    <div class="flex md:flex-row flex-col grow gap-6">
        <div class="shrink-0 w-full md:w-[290px] border-r-2 mb-4">
            <SearchFilters></SearchFilters>
        </div>
        <div class="grow">
            <SearchResults></SearchResults>
        </div>
    </div>
</template>


<style lang="scss" scoped>
@import '@/assets/styles/views/service_providers/search_results_page';
</style>
